import { type AxiosInstance } from 'axios';

import { type DistanceUnitEnum } from '../assets/enums/distance_unit.enum.ts';
import { type DocumentSlugEnum } from '../assets/enums/document-type-emun.enum.ts';
import { type TemperatureUnitEnum } from '../assets/enums/temoerature_unit.enum.ts';
import { type UpdateMeFormDto } from '../assets/forms/form-schemes.ts';
import { handleAddPhotoToFormData } from '../assets/helpers/utils/handle-add-photo-to-form-data.ts';
import type {
  CommonListArgs,
  Country,
  IsoDate,
  Nullable,
  PaginatedList,
  PartnerShort,
  RoleShort,
} from './types.ts';

export class CommonApi {
  constructor(private instance: AxiosInstance) {}

  public async getDocument(params: DocumentParams) {
    return this.instance.get<Document>(`/common/documents/${params.slug}/`).then((res) => res.data);
  }

  public async getRegions(params: RegionsListArgs) {
    return this.instance
      .get<PaginatedList<Country>>(`/common/regions/`, { params })
      .then((res) => res.data);
  }

  public async me() {
    return this.instance.get<MeResponseDto>('/common/me/').then((res) => res.data);
  }

  public async updateMe(dto: UpdateMeFormDto) {
    return this.instance
      .patch<MeResponseDto>('/common/me/', this.prepareFormDataToUpdateMe(dto))
      .then((res) => res.data);
  }

  private prepareFormDataToUpdateMe(dto: UpdateMeFormDto) {
    const formData = new FormData();
    console.log('dto:', dto);
    formData.append('username', dto.username);
    formData.append('timezone', dto.timezone);
    formData.append('temperature_unit', dto.temperature_unit);
    formData.append('distance_unit', dto.distance_unit);
    handleAddPhotoToFormData({
      formData,
      value: dto?.photo,
      propName: 'photo',
    });
    return formData;
  }
}

export type RegionsListArgs = CommonListArgs & {
  search?: string;
};
export type DocumentParams = {
  slug: string;
};

export type Document = {
  title: string;
  slug: DocumentSlugEnum;
  // date
  last_updated: IsoDate;
  content: string;
};
export type MeResponseDto = {
  id: number;
  photo: string;
  username: string;
  email: string;
  timezone: string;
  temperature_unit: TemperatureUnitEnum;
  distance_unit: DistanceUnitEnum;
  role: RoleShort;
  partner: Nullable<PartnerShort>;
};
